<template>
    <div :id="data.id + 'PanelArea'" :data-id="data.id" class="dataTableArea">
       <button :id="data.id + 'TableReload'" class="hide" v-on:click.prevent="fetchTable"></button>
        
        <button v-if="showTheArchive" class="btn-archive" v-on:click.prevent="toggleArchive">
            <i class="icon" :class="archive ? 'icon-remove-sign' : 'icon-archive'"></i>
        </button>
        <input type="text" v-model="search" v-show="data.id==='product'" id="product-search" placeholder="Filter products" v-on:keyup.enter="filter">
        <div :id="data.id + 'Table'" class="table table-striped data-table" width="100%" v-show="rows">
             
            <div class="table-header-group" >
                <div class="table-row" v-if="columns">
                    <div class="table-th" v-show="showCheckboxes">
                        <input id="checkbox-head" class="checkbox-custom" type="checkbox" @click="selectAll">
                        <label for="checkbox-head" class="checkbox-custom-label"></label>
                    </div>
                    <div class="table-th" v-for="(column, index) in columns" align="center" valign="middle" :class="'head' + index">{{ column }}</div>
                </div>
            </div>
            <div class="table-row-group" v-if="empty(rows) && !loading" v-bind:class="{ 'archived': archive }">
                <div class="table-row" @click="loadPanel" :class="buildClass(row, index)" v-for="(row, index) in rows">
                    <div class="table-td" v-show="showCheckboxes" @click.stop="select(row)">
                        <input :id="row.id + 'checkbox'" :value="row.id" v-model="selected" class="checkbox-custom" type="checkbox" />
                        <label :for="row.id + 'checkbox'" class="checkbox-custom-label"></label>
                    </div>
                    <my-row :class="colClass(col)" v-for="col in row.content" :key="col.id" v-html="col.content"></my-row>
                </div>
                <tr v-if="hasHidden && !showHidden" @click="toggleHidden" class="show-more">
                    <td :colspan="columns.length">show more <i class="icon icon-down"></i> </td>
                </tr>
            </div>

            <div class="table-row-group" v-else>
                <tr class="empty-cell table-row">
                    <td :colspan="columns.length ? columns.length : 1">
                    <span class="loading" v-show="loading"><i class="icon icon-spinner fa-spin"></i> Loading...</span>
                    <span class="not-found" v-show="!loading && !error.length">{{ no_entry_text }}</span>
                    <span class="not-found" v-show="!loading && error.length" v-html="error"></span>
                    </td>
                </tr>
            </div>
            
        </div>
        <div class="panel-footer clearfix" v-show="footer" v-html="footer"></div>
    </div>
</template>
<script>
    export default
    {
        props: {
            data: { default: '' },
            count: { default: '' },
            no_entry: { default: '' },
            show_all: { default: false },
            autosearch: { default: true },
            parent: { default: true } // Skip on occassion
        },
        components: {
            'my-row': require('./my-row.vue').default,
        },
        data: function() {
            return {
                has_archive: false,
                showArchive: false,
                hasHidden: false,
                showHidden: this.show_all,
                hasPagination: false,
                filters: {},
                no_entry_text: this.no_entry,
                getListEvent: '',
                error: '',
                page: 0,
                selected: [],
                archive: false,
                reload: false,
                loading: true,
                columns: false,
                rows: [],
                footer: false,
                search: ''
            };
        },

        created() {
            if (this.no_entry_text === '') {
                this.no_entry_text = this.trans('no_entry');
            }
            this.$eventHub.$on(this.data.id + 'toggleArchive', this.toggleArchive);
            this.$eventHub.$on(this.data.id + 'TableRefresh', this.fetchTable);
            this.$eventHub.$on(this.data.id + 'Pagination', this.paginate);
            this.$eventHub.$on(this.data.id + 'PushFilters', this.pushFilters);

            if (typeof this.data['filters'] !== 'undefined' && this.data['filters']) {
                this.filters = Object.assign({}, this.filters, this.data['filters']);
            }

            this.getListEvent = this.getUrl();
            this.$eventHub.$on(this.getListEvent, this.fetchTable);
            if (this.autosearch) {
              this.fetchTable();
            } else {
               this.loading = false;
            }
        },
        computed: {
            showTheArchive()
            {
                return this.has_archive;
            },
            showCheckboxes() {
                return false;
            },
        },
        methods : {
            colClass(col) {
                let myclass = 'col-' + col.id;
                return myclass;
            },
            buildClass(row, index) {
                let myclass = 'entity-' + row.id;
                /*if (typeof row['sub'] !== 'undefined') {
                    myclass += ' sub-row';
                }*/
                if (typeof row['class'] !== 'undefined') {
                    myclass += row['class'];
                }
                if (index >= 7 && !this.showHidden && !this.hasPagination) {
                    this.hasHidden = true;
                    myclass += ' hide-row';
                }
                return myclass;
            },
            toggleHidden() {
                this.showHidden = !this.showHidden;
            },
            pushFilters(filters) {
                // fyi('do push filters');
                this.filters = Object.assign({}, this.filters, filters);
                this.loading = true;
                this.fetchTable();
            },
            checkActive(){
                if (!this.$root.activeUrl) return;
                $('.ajaxActive').removeClass('ajaxActive');
                $('a.loadPanel[href="' + this.$root.activeUrl + '"]').parents('.table-row').addClass('ajaxActive');
            },
            selectAll(){
            },
            select(id){
                if(!id) return;
//                if(typeof this.selected[id] !== 'undefined' && this.selected[id] == true) {
//                    this.selected[id] = false;
//                }
//                this.selected[id] = true;
            },

            toggleArchive() {
                this.archive = !this.archive;
                this.fetchTable();
            },
            getUrl() {
                if (typeof this.data['url'] !== 'undefined') {
                    return this.data.url.replace(/\/$/, "") + '/get-list';
                } else if (typeof this.data['full_url'] !== 'undefined') {
                    return this.data.full_url;
                }
                // console.log(this.data);
                this.error = 'There was an error';
                return false;
            },
            fetchTable: function () {
                // == Run GET Query == //
                let url = this.getUrl();
                this.$eventHub.$emit('countUpdate' + this.data.id, 1);
                this.axios.post(url, this.getParams()).then((response) => {
                    this.footer = response.data.footer;
                    if (typeof response.data['error'] !== 'undefined') {
                        this.error = response.data.error;
                        return;
                    }
                    this.rows = response.data.rows;
                    this.hasPagination = response.data.hasPagination;
                    this.columns = response.data.headings;
                    this.has_archive = response.data.has_archive;
                    // == Add Item Counter == //
                    if(typeof response.data.count !== 'undefined') {
                        this.$eventHub.$emit('countUpdate' + this.data.id, response.data.count);
                    }
                    this.checkActive();
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                    this.error = 'Sorry, there was an error fetching your list.<br>Please contact us for assistance.';
                });
            },
            getParams() {
                let params = {
                    showArchive: this.archive
                };
                Object.assign(params, this.filters);
                if (this.page){
                    params.page = this.page;
                }
                if (typeof this.data.search !== 'undefined' && this.data.search != '') {
                    params.sSearch = this.data.search;
                }
                return params;
            },
            paginate: function(page) {
                this.page = page;
                this.fetchTable();
            },
            loadPanel: function (e) {
                // if (this.archive) return;
                if (typeof e === 'undefined') return;

                this.$eventHub.$emit('eventLoader', e)
            },
            // Check if object empty | ECMA 5+:
            empty(rows){
                if (typeof rows !== 'object') {
                    return true;
                }
                return Object.keys(rows).length !== 0;
            },
            filter() {
                this.data.search = this.search;
                this.pushFilters();
            }
        }
    };
</script>
<style lang="less" scoped>
    .dataTableArea {
        position: relative;
    }
    .btn-archive {
        position: absolute;
        z-index: 100;
        right: 0;
        top: 0;
        background: none;
        border: none;
        i {
            padding-top: 5px;
            font-size: 21px!important;
        }
    }
    .show-more {
        text-align: center;
        cursor: pointer;
        color: #39afe5;
        background: #dddddd86;
        font-weight: 800;
    }
    .table {
        display: table;
    }


    .not-found {
        padding: 15px;
        display: block;
    }

    .table-header-group {
        line-height: 110%!important;
        display: table-header-group;
    }

    .table-row {
        display: table-row;
        &.hide-row {
            display: none;
        }
    }
    .table-row-group {
        line-height: 1.9;
        display: table-row-group;
        .table-row {
            .table-td:nth-child(2) {
                font-weight: 800;
            }
            &:nth-of-type(odd) {
                background-color: hsla(0, 0%, 97.6%, .75);
            }
            &.parent-row {
                background-color: #ffffff;
                .table-td {
                    border-bottom: 1px solid #aaa;
                }
            }
            &.sub-row {
                font-size: 12px;
                background-color: rgba(70, 195, 123, 0.078);
                .table-td:nth-child(2) {
                    font-weight: 500;
                    padding: 8px 8px 8px 30px;
                }
                &.sub-row-last .table-td {
                    border-bottom: 1px solid #aaa;
                }
            }
        }
    }

    .table-th {
        font-weight: 800;
        border-bottom: 2px solid #dddddd;
    }
    .table-td {
        border-bottom: 1px solid #dddddd95;
    }
    .table-th, .table-td {
        vertical-align: middle;
        padding: 8px 15px;
        display: table-cell;
        text-align: left;
        overflow: hidden;
    }

    i.icon.icon-down {
        padding: 5px 5px 0;
    }
</style>

